export let baseUrl = 'https://api.iolpay.com/payment-api/v1.1/'
// export let baseUrl = 'https://sandbox-api.iolpay.com/payment-api/v1.1/'
export let baseEvyPayUrl = "https://evypay-api.iolpay.com/api/v1/"
// export let baseEvyPayUrl = 'https://evypay-proxy-sandbox.azurewebsites.net/api/v1/'
export const GOOGLE_PAY_ENVIRONMENT = "PRODUCTION"
export const ENCRYPTION_PUB_KEY = "LS0tLS1CRUdJTiBSU0EgUFVCTElDIEtFWS0tLS0tDQpNSUlCQ2dLQ0FRRUF2cGx2cXIwRWdsNEJMVUZHd1BYTHhOTHhGdmhVY3FEZnI1VkNSS29HSHpMcXFpa0dudGhDDQpjNTEvRThONmZWL3Nnb2NGQlFMTVF6clpuRzdudytIVFJsSE5KV3N4WnFWdjlnK0VQU2tEdW5mdU83TnFlclVzDQpiQ1JRRTdTWVBnRENRbVRYSklCMlRvOWJSOCt1SnhwWCtRNGh2cVJGS3ZrRk8xSE5rREt2eEF3NnlONjRWVG5JDQpZMUxyZ2k2V1FhRTRZWXZkVWd5Vks2bU83OGt2ZU1GczlMbWgrSFM5VGFQK1FuNFZwTm9LM3R6Tk5OMG9Wd2ppDQpta3BLQ3RQVmVGTkNtUytDTTdWTWp4ODhTY3pPLzBFQnN4TFRwSGgzVFB0UEpOckl0aW1MbGR5YloxbUprQk1tDQpJb3RsLzVtMndBQlRuLzZkMkVlNWtDLytudFZnZnVjYWFRSURBZi8vDQotLS0tLUVORCBSU0EgUFVCTElDIEtFWS0tLS0tDQo="

export const US_ZIP_CODE = /(^\d{5}$)|(^\d{5}-\d{4}$)/
export const UK_POSTAL_CODE = /^([A-Z][A-HJ-Y]?\d[A-Z\d]? ?\d[A-Z]{2}|GIR ?0A{2})$/

export const PaymentMethodsTypes = {
  Card: 0,
  AliPay: 1001,
  WeChatPay: 1002,
  Giropay: 1003,
  GooglePay: 1004,
  ApplePay: 1005,
  Tamara: 1006,
  Przelewy24: 1007,
  IDeal: 1008,
  Sofort: 1009,
  Bancontact: 1010,
  Multibanco: 1011,
  EPS: 1012,
  AlipayCN: 1013,
  PostFinance: 1014,
  PayPal: 1015,
}

export const ApmsTypes = {
  Alipay: 'alipay',
  WeChatPay: 'wechat_pay',
  Giropay: 'giropay',
  Przelewy24: 'p24',
  IDeal: 'ideal',
  Sofort: 'sofort',
  Tamara: 'tamara',
  Bancontact: 'bancontact',
  Multibanco: 'multibanco',
  EPS: 'eps',
  AlipayCN: 'alipay_cn',
  PostFinance: 'postfinance',
  PayPal: 'paypal',
}

export const APM_CODES = [
  ApmsTypes.Alipay, ApmsTypes.WeChatPay, ApmsTypes.Giropay,
  ApmsTypes.Przelewy24, ApmsTypes.IDeal, ApmsTypes.Sofort,
  ApmsTypes.Tamara, ApmsTypes.Bancontact, ApmsTypes.Multibanco,
  ApmsTypes.EPS, ApmsTypes.AlipayCN, ApmsTypes.PostFinance, ApmsTypes.PayPal,
];

export const CARD_OPTIONS = {
  showIcon: true,
  iconStyle: 'solid',
  style: {
    base: {
      fontFamily: 'Helvetica, Arial, sans-serif',
      fontSize: '13px',
      fontSmoothing: 'antialiased',
      lineHeight: '15.4388px',
      '::placeholder': {
        color: '#707070',
      },
    },
    invalid: {
      iconColor: '#d10244',
      color: '#d10244',
    },
  },
};

export const disallowedPaymentMethodsByCountry = {
  'RU': ['checkout'],
}

export const allowedCardsBrands = [
  "AMEX",
  "DISCOVER",
  "VISA",
  "MASTERCARD",
  "JCB",
  'UNIONPAY',
  "MIR"
];

export const paymentSelectorRowWidth = 3;

export const TransactionTypeName = {
  0: 'Other',
  1: 'Rooms',
  2: 'Food & Beverages',
  3: 'Spa',
  4: 'Other',
  5: 'Check Out',
  6: 'Check In',
};
